module.exports = __webpack_public_path__ + "static/img/fkl.6d06963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/fkl.png
// module id = AWlp
// module chunks = 18